export const GET_CUSTOMERS                = 'GET_CUSTOMERS';
export const SAVE_ITEM_CUSTOMER           = 'SAVE_ITEM_CUSTOMER';
export const CHANGE_VALUE_INPUTS_CUSTOMER = 'CHANGE_VALUE_INPUTS_CUSTOMER';
export const GET_INFO_CUSTOMER            = 'GET_INFO_CUSTOMER'
export const DELETE_ITEM_CUSTOMER         = 'DELETE_ITEM_CUSTOMER';
export const CUSTOMER_DEFAULT_DATA        = 'CUSTOMER_DEFAULT_DATA';